import React from 'react'
import PropTypes from 'prop-types'
import { VIEW_MODES, STATUS } from './constants'
import {
  formatNumber, formatPercent, gradeStatus, interpolateGaugeColor, satisfactionStatus
} from './utils'

const ratioFor = ({ grade, gradeMax }) => {
  if (!Number.isFinite(grade) || gradeMax <= 0)
    return 0
  return grade / gradeMax
}

const labelFor = viewMode => {
  if (viewMode === VIEW_MODES.SATISFACTION)
    return 'Score moyen du taux de satisfaction'
  return 'Score moyen de la note'
}

// Returns { value, suffix } — suffix is the muted "/gradeMax" shown only in note view.
const displayFor = ({ grade, gradeMax, viewMode }) => {
  if (viewMode === VIEW_MODES.SATISFACTION) {
    if (!Number.isFinite(grade) || gradeMax <= 0)
      return { value: '--' }
    return { value: formatPercent(grade / gradeMax * 100) }
  }
  if (!Number.isFinite(grade))
    return { value: '--' }
  return { value: formatNumber(grade), suffix: `/${gradeMax}` }
}

const statusFor = ({ grade, gradeMax, viewMode }) => {
  if (!Number.isFinite(grade))
    return STATUS.NEUTRAL
  if (viewMode === VIEW_MODES.SATISFACTION)
    return satisfactionStatus(gradeMax > 0 ? grade / gradeMax * 100 : null)
  return gradeStatus(grade, gradeMax)
}

const QuestionGradeContent = ({ question, viewMode, gradeMax }) => {
  const ratio = ratioFor({ grade: question.grade, gradeMax })
  const { value, suffix } = displayFor({ grade: question.grade, gradeMax, viewMode })
  const status = statusFor({ grade: question.grade, gradeMax, viewMode })
  const fillColor = interpolateGaugeColor(status === STATUS.NEUTRAL ? NaN : ratio)

  return (
    <div className="tw:flex tw:flex-col tw:gap-2.5">
      <div className="tw:flex tw:items-end tw:justify-between tw:text-sm">
        <span className="tw:text-gray-800">{labelFor(viewMode)}</span>
        <span className="tw:flex tw:items-baseline tw:gap-1">
          <span className="tw:font-semibold tw:text-gray-800 tw:text-xl tw:leading-none">{value}</span>
          {suffix ? <span className="tw:text-base tw:font-medium tw:text-gray-500">{suffix}</span> : null}
        </span>
      </div>
      <div className="tw:w-full tw:h-5 tw:bg-gray-200 tw:rounded-full tw:overflow-hidden">
        {/* Inline style required: width and color are dynamic per ratio. */}
        <div
          className="tw:h-full tw:rounded-full"
          style={{ width: `${Math.max(0, Math.min(1, ratio)) * 100}%`, backgroundColor: fillColor }}
        />
      </div>
    </div>
  )
}

QuestionGradeContent.propTypes = {
  gradeMax: PropTypes.number.isRequired,
  question: PropTypes.shape({
    grade: PropTypes.number
  }).isRequired,
  viewMode: PropTypes.oneOf(Object.values(VIEW_MODES)).isRequired
}

export default QuestionGradeContent
